import React from 'react';
import starIcon from '../assets/images/star.svg';
import '../assets/css/history.css';

const HistorySection = () => {
  return (
    <section id="history" className="history-section section-breakpoint">
      <div className="container">
        <div className="star-container">
          <img src={starIcon} alt="Star" className="star-icon" />
        </div>

        <h1 className="heading">
          The Breakspoll awards event and after party has taken place at some of the UK's most iconic nightclubs,
          including Electrowerkz, Egg, Fabric, Matter, Herbal, Fire, and Cable. Breakspoll has also toured
          internationally including stops in Seville (10,000 people at the Palacio De Los Deportes San Pablo Stadium)
          and Miami (WMC), and filled arenas at Glade Festival at Matterley Bowl, and Crooked Sounds at Clapham Common.
        </h1>
      </div>
    </section>
  );
};

export default HistorySection;
